var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(0.37 0.204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "twitter_1_",
    "data-name": "twitter (1)",
    d: "M23.129,50.225a9.886,9.886,0,0,1-2.732.749,4.715,4.715,0,0,0,2.086-2.621A9.476,9.476,0,0,1,19.476,49.5a4.741,4.741,0,0,0-8.2,3.242,4.882,4.882,0,0,0,.11,1.081,13.421,13.421,0,0,1-9.773-4.96A4.743,4.743,0,0,0,3.067,55.2a4.682,4.682,0,0,1-2.142-.584v.052a4.763,4.763,0,0,0,3.8,4.659,4.733,4.733,0,0,1-1.243.156,4.192,4.192,0,0,1-.9-.081,4.787,4.787,0,0,0,4.431,3.3,9.527,9.527,0,0,1-5.879,2.022A8.88,8.88,0,0,1,0,64.664a13.349,13.349,0,0,0,7.274,2.128A13.4,13.4,0,0,0,20.769,53.3c0-.21-.007-.412-.017-.613A9.459,9.459,0,0,0,23.129,50.225Z",
    transform: "translate(8.741 -37.074)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    transform: "translate(-0.37 -0.204)",
    fill: "none",
    stroke: "#9c9ca8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/Twitter Icon.a943484d8e284484a796a20722e2d886.svg";
export { ForwardRef as ReactComponent };